<template>
    <v-container grid-list-md fluid class="pa-0">
        <v-card-title class="px-0 pt-4 pb-4">
            <v-row>
                <v-col cols="auto">
                    <v-btn-back @click="$router.go(-1)" />
                </v-col>

                <v-col cols="auto">
                    <h2 class="ml-2">A nouveaux à extourner</h2>
                </v-col>

                <v-spacer />
            </v-row>
        </v-card-title>

        <v-card-title v-if="accountingPeriod && accountingPeriod.closed" class="px-0 py-2">
            <h4 class="primary--text">Période Clôturée</h4>
        </v-card-title>

        <v-card-title class="px-0 py-2" v-else-if="!previousAccountingPeriod">
            <h1 class="pa-2">N-1 n'a pas été créée dans bobbee</h1>
            <h2 class="pt-4 px-2 pb-2">Si elle existe, il faut :</h2>
            <h3 class="pa-2">- la créer</h3>
            <h3 class="pa-2">
                - importer le FEC (indispensables à la reprise automatiques des AN)
            </h3>
            <h3 class="pa-2">- la clôturer</h3>
        </v-card-title>

        <v-card-title
            class="px-0 py-2"
            v-else-if="previousAccountingPeriod && !previousAccountingPeriod.closed"
        >
            <h2 class="ml-2" style="color: #e1be7a">
                Dans "Mon dossier" - "Exercices" - N-1 doit être clôturé et les reports à nouveau
                calculés
            </h2>
        </v-card-title>

        <template v-else>
            <!-- // +++++ GL 70 ++++++++++ -->
            <v-card
                elevation="0"
                style="background-color: white; border-radius: 25px; border: 1px #ededed solid"
                class="pa-4 mt-4"
            >
                <v-row no-gutters class="px-4 d-flex align-center">
                    <v-col cols="11" class="title font-weight-bold">
                        Grand Livre N - Comptes de régularisation : lettrages à compléter avant
                        d'analyser les extournes à effectuer
                    </v-col>

                    <v-spacer />

                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-row>
                            <v-col cols="6" class="align-center">
                                <!-- <v-icon v-if="validatedPayrolls" color="secondary"  class="px-2 pt-1" icon="$check_circle" /> -->
                            </v-col>
                            <!-- <v-card-actions style="width: 20px"> -->
                            <v-col cols="6" class="align-center">
                                <v-btn-icon
                                    :icon="show3112NGL ? '$fa-chevron-up' : '$fa-chevron-down'"
                                    @click="show3112NGL = !show3112NGL"
                                    data-cy="CheckReversal-arrow"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <!-- // ** GeneralLedger -->
                <v-expand-transition>
                    <div v-show="show3112NGL">
                        <v-row>
                            <v-col :key="refreshGeneralLedger">
                                <GeneralLedger
                                    :companyId="companyId"
                                    :accountingPeriodId="accountingPeriod.id"
                                    :accountableAccountFilter="tpaas"
                                    :hideOptions="true"
                                    v-if="accountingPeriod"
                                    :inNm1="false"
                                    hideBodyAppend="true"
                                    @query-done="onQueryDone"
                                >
                                </GeneralLedger>
                                <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                            </v-col>
                        </v-row>
                    </div>
                </v-expand-transition>
            </v-card>

            <!-- // ++++++++++++++++ TABLE ++++++++++++++++++++ -->
            <!-- // +++++ collapsed documents panels -->
            <v-card
                v-if="!carryBackDocuments || !carryBackDocuments.length"
                elevation="0"
                style="background-color: white; border-radius: 25px; border: 1px #ededed solid"
                class="pa-4 mt-4"
            >
                <v-row no-gutters class="px-4 d-flex align-center">
                    <v-col cols="11" class="title font-weight-bold">
                        Aucun document N-1 contenant des comptes tiers de régularisation
                    </v-col>
                </v-row>
            </v-card>

            <v-card
                v-else
                elevation="0"
                style="background-color: white; border-radius: 25px; border: 1px #ededed solid"
                class="pa-4 mt-4"
            >
                <v-row no-gutters class="px-4 d-flex align-center">
                    <v-col cols="auto" class="title font-weight-bold">
                        Documents N-1 contenant des comptes tiers de régularisation
                    </v-col>

                    <v-col cols="auto" class="align-center pl-8">
                        <template v-if="allAlsReconciliatedInN_1WithReversalACR" >
                            <v-tooltip 
                                
                                location="bottom" 
                            >
                                <template v-slot:activator="{ props }">
                                    <v-icon
                                        color="error"
                                        class="align-center"
                                        v-bind="props"
                                        icon="$fa-exclamation-triangle"
                                    >
                                    </v-icon>
                                </template>
                                <h3>
                                    Les lignes en rouge signalent des écritures extournées en N pour, ensuite, avoir été lettrées sur un exercice précédent. N'ayant plus d'AN, il faut annuler l'extourne.
                                </h3>
                            </v-tooltip>
                        </template>
                    </v-col>

                    <v-spacer />

                    <v-col cols="2" class="d-flex align-center justify-center">
                        <v-btn
                            dense
                            rounded
                            elevation="0"
                            v-if="showGroupedReversalBtn"
                            @click="validateReversalsLoop()"
                        >
                            Extournes groupées
                        </v-btn>

                        <v-menu offset-y>
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$dots_vertical"
                                    v-bind="props"
                                    class="mx-1"
                                    color="secondary"
                                />
                            </template>

                            <v-list>
                                <v-list-item
                                    v-if="showGroupedAnnulsBtn && !accountingPeriod.closed"
                                    @click="devalidateReversalsLoop()"
                                >
                                    <v-list-item-title>Tout supprimer</v-list-item-title>
                                    <template v-slot:append>
                                        <v-icon size="small"> $oss-trash </v-icon>
                                    </template>
                                </v-list-item>

                                <v-list-item v-else disabled>
                                    <v-list-item-title> Tout supprimer </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon size="small"> $oss-trash </v-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>

                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-row>
                            <v-col cols="6" class="align-center">
                                <!-- <v-icon v-if="validatedPayrolls" color="secondary"  class="px-2 pt-1" icon="$check_circle" /> -->
                            </v-col>
                            <!-- <v-card-actions style="width: 20px"> -->
                            <v-col cols="6" class="align-center">
                                <!-- <p>tpaas : {{tpaas}}</p> -->
                                <v-btn-icon
                                    :icon="
                                        showReversalTable ? '$fa-chevron-up' : '$fa-chevron-down'
                                    "
                                    @click="showReversalTable = !showReversalTable"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-expand-transition>
                    <v-card-text class="px-0 pb-0 pt-4" v-show="showReversalTable">
                        <v-data-table
                            :headers="carryBackDocsALsHeaders"
                            :items="carryBackDocuments"
                            multi-sort
                            :loading="loading"
                            class="table"
                            style="border: 1px #ededed solid"
                            :items-per-page="-1"
                        >
                            <template #no-data>Aucun compte de régularisation mouvementé</template>

                            <template v-slot:item="props">
                                <tr :class="props.item.document.allAlsReconciliatedInN_1WithReversalACR ? 'text-error' : undefined ">
                                    <!-- // ** date -->
                                    <td v-if="props.item.document.date">
                                        {{ formatDate(props.item.document.date) }}
                                    </td>
                                    <td v-else>-</td>

                                    <!-- // ** type -->
                                    <td v-if="props.item.document.type" class="text-center">
                                        {{ $t("document.type." + props.item.document.type) }}
                                    </td>
                                    <td v-else>-</td>

                                    <!-- // ** displayName -->
                                    <td v-if="props.item.document.displayName">
                                        <v-btn-icon
                                            icon="$remove_red_eye"
                                            v-if="props.item.documentId"
                                            color="primary"
                                            @click.stop="
                                                selectedDocumentId = props.item.documentId;
                                                showDocument = true;
                                            "
                                            size="x-small"
                                        />
                                        {{ props.item.document.displayName }}
                                    </td>
                                    <td v-else>-</td>

                                    <!-- // ** reversalAccountsString -->
                                    <td
                                        v-if="props.item.reversalAccountsString"
                                        class="text-center"
                                    >
                                        {{ props.item.reversalAccountsString }}
                                    </td>
                                    <td v-else class="text-center">-</td>

                                    <!-- // ** allTPAAReconciliated -->
                                    <td
                                        v-if="props.item.document.allTPAAReconciliated"
                                        class="text-center"
                                    >
                                        Lettré
                                    </td>
                                    <td
                                        v-else-if="
                                            !props.item.document.allTPAAReconciliated &&
                                            (props.item.document.reconciliatedAaN_1.length ||
                                                props.item.document.reconciliatedAaN.length)
                                        "
                                        class="text-center"
                                    >
                                        Partiellement lettré
                                    </td>
                                    <td v-else class="text-center">-</td>

                                    <!-- // ** nb reconciliatedAaN_1 -->
                                    <td
                                        v-if="
                                            props.item.document &&
                                            props.item.document.reconciliatedAaN_1.length
                                        "
                                        class="text-center"
                                    >
                                        {{ props.item.document.reconciliatedAaN_1.length }}
                                    </td>
                                    <td v-else class="text-center">-</td>

                                    <!-- // ** nb reconciliatedAaN -->
                                    <td
                                        v-if="
                                            props.item.document &&
                                            props.item.document.reconciliatedAaN.length
                                        "
                                        class="text-center"
                                    >
                                        {{ props.item.document.reconciliatedAaN.length }}
                                    </td>
                                    <td v-else class="text-center">-</td>

                                    <!-- // ** nb existingReversalAccounts N -->
                                    <td
                                        v-if="
                                            props.item.document &&
                                            props.item.document.existingReversalAccounts.length
                                        "
                                        class="text-center"
                                    >
                                        {{
                                            props.item.document.reconciliatedAaN_1.length +
                                            props.item.document.reconciliatedAaN.length
                                        }}
                                        / {{ props.item.document.existingReversalAccounts.length }}
                                    </td>
                                    <td v-else class="text-center">-</td>

                                    <!-- // ** auditCheckResult - status -->
                                    <td
                                        v-if="
                                            props.item.auditCheckResult &&
                                            props.item.auditCheckResult.results &&
                                            props.item.auditCheckResult.results.length
                                        "
                                        class="text-center"
                                    >
                                        <v-btn-icon
                                            icon="$remove_red_eye"
                                            color="primary"
                                            class="mr-2"
                                            @click.stop="
                                                selectedDocumentId =
                                                    props.item.auditCheckResult.results[0].id;
                                                showDocument = true;
                                            "
                                            size="x-small"
                                        />
                                        Extourne N
                                    </td>
                                    <td v-else-if="props.item.ignored" class="text-center">
                                        Ignoré
                                    </td>
                                    <td v-else class="text-center">A vérifier</td>

                                    <!-- // ** actions -->
                                    <td class="text-center" style="min-width: 160px">
                                        <v-row no-gutters>
                                            <!-- // ** ignore -->
                                            <v-col
                                                cols="6"
                                                v-if="!props.item.auditCheckResult"
                                                class="d-flex align-center justify-center"
                                            >
                                                <v-btn
                                                    v-if="
                                                        accountingPeriod.closed &&
                                                        !props.item.ignored
                                                    "
                                                    disabled
                                                    rounded
                                                    elevation="0"
                                                    size="x-small"
                                                >
                                                    Ignorer
                                                </v-btn>
                                                <v-btn
                                                    v-else-if="
                                                        !props.item.ignored &&
                                                        !props.item.auditCheckResult
                                                    "
                                                    rounded
                                                    elevation="0"
                                                    @click="
                                                        props.item.ignored = true;
                                                        validateReversals(props.item);
                                                    "
                                                    size="x-small"
                                                >
                                                    Ignorer
                                                </v-btn>
                                                <h3 v-else />
                                            </v-col>

                                            <!-- // ** reversal -->
                                            <v-col
                                                cols="6"
                                                v-if="!props.item.auditCheckResult"
                                                class="d-flex align-center justify-center"
                                            >
                                                <v-btn
                                                    v-if="accountingPeriod.closed"
                                                    disabled
                                                    rounded
                                                    elevation="0"
                                                    size="x-small"
                                                >
                                                    Exercice clôturé
                                                </v-btn>
                                                <v-btn
                                                    v-else-if="!props.item.auditCheckResult"
                                                    rounded
                                                    elevation="0"
                                                    @click="validateReversals(props.item)"
                                                    size="x-small"
                                                >
                                                    Extourner
                                                </v-btn>
                                            </v-col>

                                            <!-- // ** delete acr -->
                                            <v-col
                                                v-else
                                                cols="12"
                                                class="d-flex align-center justify-center"
                                            >
                                                <v-btn
                                                    v-if="accountingPeriod.closed"
                                                    disabled
                                                    rounded
                                                    elevation="0"
                                                    size="x-small"
                                                >
                                                    Annuler
                                                </v-btn>
                                                <v-btn
                                                    v-else
                                                    color="primary"
                                                    rounded
                                                    elevation="0"
                                                    @click="devalidateReversals(props.item)"
                                                    size="x-small"
                                                >
                                                    Annuler
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-expand-transition>
            </v-card>
        </template>

        <oss-dialog
            v-model="showDocument"
            :withoutHeader="true"
            transition="dialog-bottom-transition"
            v-if="showDocument && selectedDocumentId"
            min-width="90vw"
        >
            <v-row class="d-flex justify-center">
                <v-col cols="12" style="overflow-y: auto">
                    <Document
                        :mode="'GeneralLedger'"
                        :companyId="selectedCompany.id"
                        :id="selectedDocumentId"
                        :dark-mode="true"
                        @openReconciliation="openReconciliation"
                    />
                </v-col>
            </v-row>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { sumBy } from "lodash";

import { Apollo } from "@/decorators";
import { mathFix } from "../../services/mathServices";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import DELETE_AUDIT_CHECK_RESULTS_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultIds.gql";

import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";

import CREATE_RECONCILIATION from "../../graphql/reconciliation/CreateReconciliation.gql";

import AccountableAccountVue from "../AccountableAccount.vue";
import Document from "../document/DocumentRouter.vue";
import GeneralLedger from "../GeneralLedger2.vue";
import { CheckBase } from "./CheckBase";
import { getEmptyDocument } from "../../services/documentServices";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccountVue,
        Document,
        GeneralLedger,
    },
    emits: ["openReconciliation"],
})
export class CheckReversal extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;

    loading: boolean = false;

    previousAccountingPeriod: any = {};

    company: any = {};

    auditCheckKey: string = "pyRY2v52Qw3v9562P5HRyiMDe";
    auditCheckResult: any = {};
    currentDocACRid: string = "";
    previousDocumentsIds: Array<any> = [];
    resultDocumentIdsToDelete: Array<any> = [];

    show3112NGL: boolean = false;
    showReversalTable: boolean = false;
    showDocument: boolean = false;
    refreshGeneralLedger: number = 0;
    selectedDocumentId: string = "";

    allAlsReconciliatedInN_1WithReversalACR: boolean = false

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    // get accountingPeriod() {
    //     if (!this.accountingPeriodId) return null
    //     return this.accountingPeriods.find(aa => aa.id === this.accountingPeriodId)
    // }

    setAccountingPeriodName(period) {
        const start = moment(period.start).format("DD MMM YYYY");
        const end = moment(period.end).format("DD MMM YYYY");
        if (period.closed === false) {
            return "Du " + start + " au " + end;
        }
        return "Du " + start + " au " + end + " - Période clôturée";
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    // ++++++++++++ HEADERS +++++++++
    carryBackDocsALsHeaders: Array<any> = [
        {
            title: "Date",
            value: "date",
            align: "left",
            sortable: true,
        },
        {
            title: "Type",
            value: "type",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "displayName",
            align: "left",
            sortable: true,
        },
        {
            title: "Comptes tiers mouvementés",
            value: "wording",
            align: "center",
            sortable: true,
        },
        {
            title: "Lettrages",
            value: "reconciliatedAaN_1",
            align: "center",
            sortable: true,
        },
        {
            title: "L N-1",
            value: "reconciliatedAaN_1",
            align: "center",
            sortable: true,
        },
        {
            title: "L N",
            value: "reconciliatedAaN",
            align: "center",
            sortable: true,
        },
        {
            title: "Situation lettrages",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            title: "Statut",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            title: "Actions",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    afterAccountingPeriodFound() {
        if (this.accountingPeriod) {
            const previousPeriodEnd = moment(this.accountingPeriod.start)
                .add(-1, "days")
                .format("YYYY-MM-DD");

            this.previousAccountingPeriod = this.accountingPeriods.find(
                (ap) => moment(ap.end).format("YYYY-MM-DD") === previousPeriodEnd,
            );
        }
    }

    // ***********************************************************
    // ********** APOLLO - INVOICES LIST - NETAMOUNT OVER 500€ ***
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.auditCheckKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.allAlsReconciliatedInN_1WithReversalACR = false

                if (data && data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.auditItems = JSON.parse(JSON.stringify(data.auditItems.items[0]));
                    if (this.auditItems.company) {
                        this.company = this.auditItems.company;
                    } else {
                        debugger; // git-ignore
                    }

                    this.tpaas = this.auditItems.tpaas || [];

                    // ** filter in back previous acrs
                    // ** and receive only without acr or with thisPeriodAcr
                    if (this.auditItems.carryBackDocuments) {
                        const carryBackDocuments: any = JSON.parse(
                            JSON.stringify(this.auditItems.carryBackDocuments),
                        );

                        this.allAlsReconciliatedInN_1WithReversalACR = this.accountingPeriod && !this.accountingPeriod.closed && carryBackDocuments.some(cbd => cbd.document.allAlsReconciliatedInN_1WithReversalACR)

                        for (const cbd of carryBackDocuments) {
                            if (cbd.document?.existingReversalAccounts?.length) {
                                cbd.reversalAccountsString = "";

                                if (cbd.document.existingReversalAccounts.length === 1) {
                                    cbd.reversalAccountsString =
                                        cbd.document.existingReversalAccounts[0].slice(0, 6);
                                } else {
                                    for (const praa of cbd.document.existingReversalAccounts) {
                                        cbd.reversalAccountsString += praa.slice(0, 6) + " ";
                                    }
                                }
                            }

                            cbd.ignored =
                                cbd.auditCheckResult?.data?.[0]?.reversal?.ignored || false;

                            if (cbd.auditCheckResult) {
                                if (
                                    cbd.auditCheckResult.results &&
                                    cbd.auditCheckResult.results[0] &&
                                    cbd.auditCheckResult.results[0].id
                                ) {
                                    this.previousDocumentsIds.push({
                                        originalDocumentId: cbd.document.id,
                                        acrDocumentId: cbd.auditCheckResult.results[0].id,
                                    });
                                }
                                if (cbd.auditCheckResult.data && cbd.auditCheckResult.data[0]) {
                                    cbd.document.reversalSwitch =
                                        cbd.auditCheckResult.data[0].reversal?.reversalSwitch ||
                                        true;
                                }
                            } else {
                                cbd.document.reversalSwitch = true;
                            }
                        }

                        this.carryBackDocuments = carryBackDocuments;

                        if (this.auditItems.auditCheckResult) {
                            // **** FULL ****
                            this.auditCheckResult = this.auditItems.auditCheckResult;

                            if (this.auditCheckResult.results) {
                                this.previousDocumentsIds = this.auditCheckResult.results.map(
                                    (rd) => rd.id,
                                );
                            }
                            if (this.auditCheckResult.data) {
                                debugger; // git-ignore
                            }
                        }
                    } else {
                        this.carryBackDocuments = [];
                    }
                } else {
                    this.carryBackDocuments = [];
                }
            }
        },
    })
    auditItems: any;

    carryBackDocuments: Array<any> = [];

    tpaas: Array<string> = [];

    initialiseCompany() {
        this.auditItems = [];
        this.currentDocACRid = "";
        this.resultDocumentIdsToDelete = [];
        this.previousDocumentsIds = [];
        this.auditCheckResult = {};
        this.company = {};
        // this.show3112NGL = false
        // this.showReversalTable = true
        this.refreshGeneralLedger++;
        this.showDocument = false;
        this.selectedDocumentId = "";
    }

    // ++ DE VALIDATE REVERSALS
    async singleDevalidateReversals(doc) {
        if (doc.auditCheckResult && doc.auditCheckResult.id) {
            await this.$apollo.mutate({
                mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
                variables: {
                    // documentId: rdi
                    id: doc.auditCheckResult.id,
                },
            });
        }
    }

    async devalidateReversalsLoop() {
        const acrIds = [];
        for (const doc of this.carryBackDocuments) {
            if (doc.auditCheckResult?.results?.length || doc.ignored) {
                acrIds.push(doc.auditCheckResult.id);
            }
        }

        if (acrIds.length) {
            await this.$apollo.mutate({
                mutation: DELETE_AUDIT_CHECK_RESULTS_AND_RESULTS,
                variables: {
                    ids: acrIds,
                },
            });
        }

        this.refresh();
    }

    async devalidateReversals(doc) {
        await this.singleDevalidateReversals(doc);

        this.refresh();
    }

    // ++ VALIDATE REVERSALS
    async singleValidateReversal(doc) {
        // async validateReversals(doc) {
        const reversalYear = moment(this.accountingPeriod.start)
            .clone()
            .add(-1, "years")
            .format("YYYY");
        const documents = [];
        const currentDocumentData = [];
        const alDate = moment(this.accountingPeriod.start).startOf("day");

        if (!doc.ignored) {
            const accountingLines = [];
            let reversalDocument: any = {};

            for (const aL of doc.document.accountingLines) {
                const aLObject = {
                    date: alDate,
                    wording: "Ext. " + reversalYear + " - " + aL.wording,
                    amountSigned: -aL.amountSigned || 0,
                    amount: Math.abs(aL.amountSigned),
                    // eslint-disable-next-line no-await-in-loop
                    accountableAccount: await getConnectAccountableAccount(
                        this.$store,
                        this.$apollo,
                        aL.accountableAccount.name,
                    ),
                    company: { connect: { id: this.companyId } },
                    type: "ACCOUNTING",
                };
                accountingLines.push({ ...aLObject });
            }

            reversalDocument = getEmptyDocument(
                this.companyId,
                accountingLines[0].wording,
                "MISCELLANEOUS_OPERATION",
                // ERIC DATE TO CHECK BY MONICA
                alDate,
                this.currentUser.id,
                null,
                accountingLines,
                true,
            );
            // reversalDocument.data = {
            //     // reversal: {
            //     accountingLines: accountingLines
            //     // }
            // }
            documents.push(reversalDocument);
        }

        // ************ data ******************
        currentDocumentData.push({
            reversal: {
                // company: this.companyId,
                documentId: doc.documentId,
                date: alDate,
                wording: "Ext. " + reversalYear + " - " + doc.document.accountingLines[0].wording,
                ignored: doc.ignored || false,
            },
        });

        // ************ APOLLO MUTATE *****************
        // **** UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT
        // **** accepts only one single original document
        // **** to append generated new documuments ids

        const upsertVariables = {
            id: doc.auditCheckResult?.id || "",
            auditCheckKey: this.auditCheckKey,
            key: this.auditCheckKey + "_" + this.companyId + "_" + doc.documentId,
            companyId: this.companyId,
            status: "UNKNOWN",
            // thirdPartyCompanyCreate: undefined,
            // thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // accountingLineCreateConnection: {connect: {id: currentAlAcrData.alId}},
            // accountingLineUpdateConnection: {connect: {id: currentAlAcrData.alId}},
            documentCreateConnection: { connect: { id: doc.documentId } },
            documentUpdateConnection: { connect: { id: doc.documentId } },
            // bankTransactionCreateConnection: {connect: {id: doc.documentId}},
            // bankTransactionUpdateConnection: {connect: {id: doc.documentId}},
            deleteDocuments: [],
            documents: documents,
            data: JSON.parse(JSON.stringify(currentDocumentData)) || [],
        };

        const result = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
            variables: upsertVariables,
        });

        if (result?.data?.upsertAuditCheckResult && documents.length) {
            const acrResult = result.data.upsertAuditCheckResult;

            const documentPlusReversalAccountingLines = [
                ...doc.document.accountingLines,
                ...acrResult.results[0].accountingLines,
            ];

            if (documentPlusReversalAccountingLines?.length) {
                const reconciliationAccountingLinesIds = [];
                for (const tpaa of this.tpaas) {
                    const tpaaDocumentPlusReversalAccountingLines =
                        documentPlusReversalAccountingLines.filter((al) =>
                            al.accountableAccount.name.startsWith(tpaa),
                        );
                    if (tpaaDocumentPlusReversalAccountingLines?.length) {
                        const alSum = mathFix(
                            sumBy(tpaaDocumentPlusReversalAccountingLines, "amountSigned"),
                            2,
                        );
                        if (alSum === 0) {
                            const tpaaAlIds = tpaaDocumentPlusReversalAccountingLines.map((al) => ({
                                id: al.id,
                            }));
                            reconciliationAccountingLinesIds.push(...tpaaAlIds);
                        } else {
                            console.error("Reconciliation sum != 0");
                            debugger;
                        }
                    }
                }

                if (reconciliationAccountingLinesIds.length) {
                    const upsertReconciliationVariables = {
                        type: "DEFAULT",
                        status: "VALIDATED",
                        companyId: this.companyId,
                        bankTransactions: [],
                        accountingLines: reconciliationAccountingLinesIds,
                    };

                    await this.$apollo.mutate({
                        mutation: CREATE_RECONCILIATION,
                        variables: upsertReconciliationVariables,
                    });
                }
            }
        }
    }

    // ******************* GENERATE Reversals ****************
    async validateReversals(doc) {
        await this.singleValidateReversal(doc);

        this.refresh();
    }

    async validateReversalsLoop() {
        for (const doc of this.carryBackDocuments) {
            if (!doc.auditCheckResult?.results?.length && !doc.ignored) {
                await this.singleValidateReversal(doc);
            }
        }

        this.refresh();
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            // eslint-disable-next-line
            debugger; // git-ignore
        }

        this.initialiseCompany();
    }

    openReconciliation(data) {
        this.$emit("openReconciliation", data);
    }

    onQueryDone(data) {}

    sumFieldCharges(documentId) {
        const charges = [];
        if (this.carryBackDocuments.length) {
            const currentDoc = this.carryBackDocuments.filter(
                (doc) => doc.documentId === documentId,
            );

            const docCharges = currentDoc[0].document.accountingLines.filter(
                (al) => al.amountSigned > 0,
            );

            for (const amount of docCharges) {
                charges.push(amount.amountSigned);
            }

            return charges.reduce((a, b) => a + (b || 0), 0);
        }
        return 0;
    }

    sumFieldIncomes(documentId) {
        const incomes = [];
        if (this.carryBackDocuments.length) {
            const currentDoc = this.carryBackDocuments.filter(
                (doc) => doc.documentId === documentId,
            );

            const docIncomes = currentDoc[0].document.accountingLines.filter(
                (al) => al.amountSigned < 0,
            );

            for (const amount of docIncomes) {
                incomes.push(amount.amountSigned);
            }

            return incomes.reduce((a, b) => a + (b || 0), 0);
        }
        return 0;
    }

    sumField(documentId) {
        const balance = [];
        if (this.carryBackDocuments.length) {
            const currentDoc = this.carryBackDocuments.filter(
                (doc) => doc.documentId === documentId,
            );

            for (const amount of currentDoc[0].document.accountingLines) {
                balance.push(amount.amountSigned);
            }

            return balance.reduce((a, b) => a + (b || 0), 0);
        }
        return 0;
    }

    get showGroupedReversalBtn() {
        if (this.carryBackDocuments.length) {
            const documentWithoutACR = this.carryBackDocuments.find((doc) => !doc.auditCheckResult);
            return documentWithoutACR ? true : false;
        }
        return false;
    }

    get showGroupedAnnulsBtn() {
        if (this.carryBackDocuments.length) {
            const documentWithACR = this.carryBackDocuments.find((doc) => doc.auditCheckResult);
            return documentWithACR ? true : false;
        }
        return false;
    }
}

export default toNative(CheckReversal);
</script>
